import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { StartupBoundary } from "./StartupBoundary";
import "./index.css";
import "./mobile-redesign.css";
import { installUnifiedBridge } from "./core/unifiedBridge";
import { initializeAudioRuntime } from "./core/audioRuntime";
import { initializeProductionTelemetry } from "./telemetry";

installUnifiedBridge();
initializeAudioRuntime();
initializeProductionTelemetry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <StartupBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </StartupBoundary>
  </React.StrictMode>,
);
